import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { debounce } from '@outdoor-voices/ui';
import { RESIZE } from '@outdoor-voices/ui/dist/config/constants';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { CollectionContext } from '../../apps/collection/context';
import { COMPONENTS } from './constants';
import { mobileBreak } from './utils';
import Breadcrumbs from '../Breadcrumbs';
import TextOnly from './TextOnly';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Hero = function Hero(_ref) {
  var breadcrumbsNode = _ref.breadcrumbs,
      component = _ref.component,
      description = _ref.description,
      image = _ref.image,
      imageMobile = _ref.imageMobile,
      pageTitle = _ref.pageTitle,
      subtitle = _ref.subtitle,
      textColor = _ref.textColor,
      title = _ref.title;

  var _useContext = useContext(CollectionContext),
      fabrics = _useContext.fabrics,
      gender = _useContext.gender;

  var _useState = useState(mobileBreak()),
      _useState2 = _slicedToArray(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1]; // Change the isMobile state based on the width of the browser


  useEffect(function () {
    var onResize = function onResize() {
      setIsMobile(mobileBreak());
    }; // Debounce the listener, so we don't re-render too much


    var debouncedResize = debounce(onResize, 500);
    window.addEventListener(RESIZE, debouncedResize); // Remove the listener for cleanup on re-render

    return function () {
      window.removeEventListener(RESIZE, debouncedResize);
    };
  }, []);
  var heroComponent = COMPONENTS[component.toUpperCase()];
  var breadcrumbsComponent = pageTitle ? /*#__PURE__*/_jsx(Breadcrumbs, {
    customBreadcrumbNodes: breadcrumbsNode === null || breadcrumbsNode === void 0 ? void 0 : breadcrumbsNode.edges,
    showFabrics: fabrics,
    genderFilter: gender,
    heroType: component.toUpperCase(),
    pageTitle: pageTitle
  }) : null;

  if (image && heroComponent) {
    var activeImage = isMobile && imageMobile ? imageMobile : image;
    var heroComponentProps = heroComponent.props ? heroComponent : [];
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [breadcrumbsComponent, /*#__PURE__*/_jsx(heroComponent.component, _objectSpread({
        component: component,
        description: description,
        image: activeImage,
        imageMobile: imageMobile,
        subtitle: subtitle || 'Explore the Collection',
        textColor: textColor,
        title: title
      }, heroComponentProps))]
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [breadcrumbsComponent, /*#__PURE__*/_jsx(TextOnly, {
      description: description,
      textColor: textColor,
      title: title
    })]
  });
};

Hero.displayName = 'Hero';
Hero.defaultProps = {
  breadcrumbs: {
    edges: []
  },
  component: false,
  description: false,
  image: false,
  imageMobile: false,
  pageTitle: false,
  subtitle: false,
  title: false
};
Hero.propTypes = {
  breadcrumbs: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape())
  }),
  component: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  description: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  imageMobile: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  pageTitle: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  subtitle: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  textColor: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
};
export default Hero;